<div class="overview-content">

    <table class="ov-table" mat-table #TableOverview [dataSource]="HTML_TableDataSource"
        class="mat-elevation-z8 medium-border-arma-color overview-element">

        <ng-container matColumnDef="1">
            <th mat-header-cell *matHeaderCellDef> {{HTML_TableTitle[0]}} </th>
            <td mat-cell *matCellDef="let element">{{element.Name}}</td>
        </ng-container>

        <ng-container matColumnDef="2">
            <th class="ov-number-end" mat-header-cell *matHeaderCellDef> {{HTML_TableTitle[1]}} </th>
            <td class="ov-number-end" mat-cell *matCellDef="let element">{{element.Data}}</td>
        </ng-container>

        <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TableaHeader;"></tr>
        <tr mat-row *matRowDef="let row; columns: HTML_TableaHeader;"></tr>

    </table>
    <div class="overview-element">
        <ng-container *ngIf="HTML_img1; else elseTemplate">
            <img class="medium-border-arma-color block-img" [src]="HTML_img1" alt="Report">
        </ng-container>
        <ng-template #elseTemplate>
            <mat-spinner></mat-spinner>
        </ng-template>
    </div>

    <div class="overview-element">
        <ng-container *ngIf="HTML_imgDeliveredWeightPerDiameter; else elseTemplate2">
            <img class="medium-border-arma-color block-img" [src]="HTML_imgDeliveredWeightPerDiameter" alt="Delivery Weight">
        </ng-container>
        <ng-template #elseTemplate2>
            <mat-spinner></mat-spinner>
        </ng-template>
    </div>

    <div class="overview-element">
        <ng-container *ngIf="HTML_img2; else elseTemplate2">
            <img class="medium-border-arma-color block-img" [src]="HTML_img2" alt="Delivery Weight">
        </ng-container>
        <ng-template #elseTemplate2>
            <mat-spinner></mat-spinner>
        </ng-template>
    </div>
</div>